var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountMenu6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_413_1",
    "data-name": "Component 413 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 76.328,
    height: 88.193,
    viewBox: "0 0 76.328 88.193",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4744",
    "data-name": "Rectangle 4744",
    width: 76.328,
    height: 88.193,
    fill: "none",
    stroke: "#707070",
    strokeWidth: 2
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4534",
    "data-name": "Group 4534",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6065",
    "data-name": "Path 6065",
    d: "M44.493,46.648V47.7a6.484,6.484,0,0,0,6.484,6.484h2.776A6.484,6.484,0,0,0,60.237,47.7v-1.05l-.092-3.566v-.054a8.348,8.348,0,0,1,2.439-5.936,14.516,14.516,0,1,0-20.562-.127,8.668,8.668,0,0,1,2.565,6.065v.052h7.78",
    transform: "translate(-14.2 -4.605)",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1033",
    "data-name": "Line 1033",
    y1: 3.33,
    transform: "translate(38.164 0.938)",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1034",
    "data-name": "Line 1034",
    x1: 1.139,
    y1: 3.13,
    transform: "translate(30.894 2.352)",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1035",
    "data-name": "Line 1035",
    x1: 2.141,
    y1: 2.551,
    transform: "translate(24.547 6.167)",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1036",
    "data-name": "Line 1036",
    x1: 2.884,
    y1: 1.665,
    transform: "translate(19.887 11.923)",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1037",
    "data-name": "Line 1037",
    y1: 3.13,
    x2: 1.139,
    transform: "translate(44.295 2.352)",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1038",
    "data-name": "Line 1038",
    y1: 2.551,
    x2: 2.141,
    transform: "translate(49.641 6.167)",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1039",
    "data-name": "Line 1039",
    y1: 1.665,
    x2: 2.884,
    transform: "translate(53.557 11.923)",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6066",
    "data-name": "Path 6066",
    d: "M62.918,47.939a24.556,24.556,0,1,1-33.422.238",
    transform: "translate(-8.171 -17.986)",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6067",
    "data-name": "Path 6067",
    d: "M20.451,36.28a17.238,17.238,0,0,1-10.218.643l-2.159-.535L1.5,47.774l1.539,1.6a17.527,17.527,0,0,1,4.8,12.253v.154a17.446,17.446,0,0,1-4.8,12.2l-1.54,1.6L8.074,86.965l2.156-.534a17.443,17.443,0,0,1,12.963,1.942l.134.077a17.525,17.525,0,0,1,8.211,10.284l.615,2.133H45.3l.617-2.137a17.5,17.5,0,0,1,8.193-10.273l.059-.034.059-.034a17.5,17.5,0,0,1,12.993-1.959l2.159.534,6.574-11.386-1.539-1.6a17.525,17.525,0,0,1-4.8-12.253c0-.052,0-.1,0-.155a17.446,17.446,0,0,1,4.8-12.2l1.54-1.6L69.38,36.388l-2.156.534A17.223,17.223,0,0,1,57,36.282",
    transform: "translate(-0.563 -13.611)",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6068",
    "data-name": "Path 6068",
    d: "M62.935,84.528a4.643,4.643,0,0,1-9.287,0",
    transform: "translate(-20.128 -31.713)",
    fill: "none",
    stroke: "#344154",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6069",
    "data-name": "Path 6069",
    d: "M54.62,25.017A13.8,13.8,0,0,1,65.333,30.1c.034-.351.052-.705.052-1.063A10.767,10.767,0,0,0,54.622,18.272q-.385,0-.775.027A10.664,10.664,0,0,0,43.92,30.082a13.8,13.8,0,0,1,10.7-5.065",
    transform: "translate(-16.455 -6.855)",
    fill: "#ffbf00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountMenu6);
export default __webpack_public_path__ + "static/media/AccountMenu-6.421b2ddc704479ba7f004fdbfd372723.svg";
export { ForwardRef as ReactComponent };